import lang from "@/views/modules/MultiBranchs/language/en";
//import Editor from '@tinymce/tinymce-vue';
export default {
    name: "edit-example",
    components: {
//        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            multibranchObj: {},
            lang:[],
        }
    },
    mounted() {
        this.getData();
        this.lang = lang;
    },
    methods: {
        getData() {
            const self = this;
            self.loading = true;
             window.currentAction = 'detail';
                axios.get('api/modules/multibranchs/' + self.$route.params.id).then(function (response) {
                self.multibranchObj = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        
    }
}